export var getFileNameInPath = function getFileNameInPath(path, reg) {
  return path.split('/').pop().replace(reg, '');
};
export var isFilePath = function isFilePath(path, reg) {
  return reg.test(path);
};
export var isType = function isType(chart, type) {
  return !chart.type || chart.type === type;
};